import { AxiosError } from 'axios';

import {
    AppConfigDTO,
    Completable,
    KashableResponseDTO
} from 'kashable-mobile-common';

import { errored, mapSucceeded } from '../utils/AxiosUtils';

import axios from './base';

const getAppConfig = (): Promise<Completable<AppConfigDTO>> => {
    return axios
        .get<KashableResponseDTO<AppConfigDTO>>('/secured/user/app/config')
        .then((res) => mapSucceeded(res, (d: KashableResponseDTO<AppConfigDTO>) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

export {getAppConfig};